<template>
    <DCard
        padding
    >
        <DRow
            align-horizontal="start"
            align-vertical="end"
            class="mb-3"
        >
            <DCol lg="3">
                <DInput
                    id="search"
                    v-model="filtersData.search"
                    :label="__('contracts.duplicates.duplicates_search') "
                    @keydown.enter.exact.prevent="search"
                />
            </DCol>
            <DCol
                lg="3"
                class="d-flex gap-2"
            >
                <DButton
                    id="filter-apply"
                    :label="__('contracts.duplicates.search')"
                    @click="search"
                />
                <DButton
                    id="filter-reset"
                    :label="__('messages.actions.reset_filter')"
                    icon="filter-off"
                    @click="resetSearch"
                />
            </DCol>
        </DRow>
        <section class="contracts-table">
            <header>
                <div>{{ __('contracts.duplicates.table.contract_id') }}</div>
                <div>{{ __('contracts.duplicates.table.customer') }}</div>
                <div>{{ __('contracts.duplicates.table.status') }}</div>
                <div>{{ __('contracts.duplicates.table.price') }}</div>
                <div>{{ __('contracts.duplicates.table.start_date') }}</div>
                <div>{{ __('contracts.duplicates.table.billed_until') }}</div>
            </header>
            <main v-if="contracts.data.length > 0">
                <div
                    v-for="(item, index) in contracts.data"
                    :key="index"
                    class="item-group"
                >
                    <div class="item-header">
                        <div>
                            <DButton
                                mini
                                :icon="!collapsedGroups.includes(index) ? 'arrow-up' : 'arrow-down'"
                                @click="toggleGroup(index)"
                            />
                        </div>
                        <div>{{ item.external_id }}</div>
                    </div>
                    <div
                        v-show="!collapsedGroups.includes(index)"
                        class="item"
                    >
                        <div />
                        <div>
                            <Link :href="customerContractsUrl(item.customer_id, item.id)">
                                {{ item.id }}
                            </Link>
                        </div>
                        <div>
                            <Link :href="customerProfileUrl(item.customer_id)">
                                <div v-if="item.company">
                                    {{ item.company }}<br>
                                </div>
                                <span v-else>
                                    {{ item.firstname }} {{ item.lastname }}
                                </span>
                                ({{ item.customer_id }})
                            </Link>
                        </div>
                        <div>{{ item.status }}</div>
                        <div>{{ priceFormatForDisplay(item.price, 2, item.customer_market_region_id) }}</div>
                        <div>{{ setDateFormat(item.start_date) }}</div>
                        <div>{{ setDateFormat(item.billed_until_date) }}</div>
                    </div>
                    <div
                        v-for="(duplicateContract, indexDuplicateProduct) in item.duplicates"
                        v-show="!collapsedGroups.includes(index)"
                        :key="indexDuplicateProduct"
                        class="item"
                    >
                        <div />
                        <div>
                            <Link :href="customerContractsUrl(duplicateContract.customer_id, duplicateContract.id)">
                                {{ duplicateContract.id }}
                            </Link>
                        </div>
                        <div>
                            <Link :href="customerProfileUrl(duplicateContract.customer_id)">
                                <div v-if="duplicateContract.company">
                                    {{ duplicateContract.company }}<br>
                                </div>
                                <span v-else>
                                    {{ duplicateContract.firstname }} {{ duplicateContract.lastname }}
                                </span>
                                ({{ duplicateContract.customer_id }})
                            </Link>
                        </div>
                        <div>{{ duplicateContract.status }}</div>
                        <div>{{ priceFormatForDisplay(duplicateContract.price, 2, duplicateContract.customer_market_region_id) }}</div>
                        <div>{{ setDateFormat(duplicateContract.start_date) }}</div>
                        <div>{{ setDateFormat(duplicateContract.billed_until_date) }}</div>
                    </div>
                </div>
            </main>
            <div
                v-else
                class="p-2"
            >
                <DAlert
                    color="danger"
                    class="text-center"
                >
                    {{ __('contracts.duplicates.no_duplicates') }}
                </DAlert>
            </div>
            <DPagination
                v-if="contracts.last_page > 1"
                class="mt-3"
                :active-page="contracts.current_page"
                :pages="contracts.last_page"
                align="center"
                @update:activePage="changePage"
            />
        </section>
    </DCard>
</template>

<script>

import _ from 'lodash'
import priceFormat from '~@/Mixins/priceFormat'

export default {
    name: 'DuplicateContractIndex',
    mixins: [
        priceFormat
    ],
    props: {
        contracts: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        filters: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            collapsedGroups: [],
            filtersData: _.cloneDeep(this.filters)
        }
    },
    methods: {
        toggleGroup (index) {
            if (this.collapsedGroups.includes(index)) {
                this.collapsedGroups = this.collapsedGroups.filter(e => e !== index)
            } else {
                this.collapsedGroups.push(index)
            }
        },
        customerProfileUrl (customerId) {
            return this.$route('customers.customers.show', {
                customer: customerId
            })
        },
        customerContractsUrl (customerId, contractId) {
            return this.$route('customers.customers.contracts.index', {
                customer: customerId,
                _query: {
                    contract: contractId
                }
            })
        },
        changePage (page) {
            const query = {}

            if (page > 1) {
                query.page = page
            }

            this.$inertia.get(this.$route('contracts.duplicates'), query)
        },
        search (defaultFilters = false) {
            this.$inertia.get(this.$route('contracts.duplicates', {
                _query: {
                    search: this.filtersData.search.trim()
                },
                save_filters: true,
                defaultFilters: defaultFilters
            }))
        },
        resetSearch () {
            this.filtersData.search = ''
            this.search(true)
        }
    }
}
</script>

<style scoped>
.contracts-table {
}
.contracts-table header {
    border-bottom: 1px solid rgba(0,0,0,0.14);
    display: grid;
    grid-template-columns: 3% 1fr 17% 16% 16% 16% 16%;
    grid-gap: 10px;
}
.contracts-table header > div:nth-child(1) {
    grid-column: 2;
}
.contracts-table header > div {
    padding: 10px;
    font-weight: bold;
}
.contracts-table main {
}
.contracts-table main .item-group {
    border-bottom: 1px solid rgba(0,0,0,0.3);
    position: relative;
}
.contracts-table main .item-group .item-header {
    display: grid;
    grid-template-columns: 4% 1fr 16% 16% 16% 16% 16%;
    grid-gap: 10px;
    background: #fff;
    border-bottom: 1px solid rgba(0,0,0,0.14);
    position: sticky;
    top: -25px;
    width: auto;
    z-index: 100;
}
.contracts-table main .item-group .item-header > div {
    padding: 10px;
    align-self: center;
}
.contracts-table main .item-group .item-header > div:nth-child(2) {
    grid-column: 2 / span 2;
    font-weight: bold;
}
.contracts-table main .item-group .item {
    display: grid;
    grid-template-columns: 4% 1fr 16% 16% 16% 16% 16%;
    grid-gap: 10px;
}
.contracts-table main .item-group .item > div {
    padding: 10px;
    align-self: center;
}
.contracts-table main .item-group .item > div:nth-child(1) {
    position: relative;
    overflow: hidden;
    padding: 0;
    height: 100%;
}
.contracts-table main .item-group .item > div:nth-child(1)::after {
    content: "";
    display: block;
    position: absolute;
    left: 21px;
    top: 0;
    width: 2px;
    height: 60px;
    background: rgba(0,0,0,0.07);
}
.contracts-table main .item-group .item > div:nth-child(1)::before {
    content: "";
    display: block;
    position: absolute;
    left: 23px;
    top: 25px;
    width: 10px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    height: 2px;
    background: rgba(0,0,0,0.07);
}
.contracts-table main .item-group .item:last-of-type > div:nth-child(1)::after {
    height: 35px;
    background: rgba(0,0,0,0.07);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}
.contracts-table main .item-group .item:hover {
    background: rgba(0,0,0,0.07);
}
</style>
